<template>
  <div
    v-if="show"
    :class="['product-sticky-header', { 'product-sticky-header--show' : show }]"
  >
    <div class="container container--main">
      <slot />
    </div>
  </div>
</template>

<script>
  import { throttle } from '@Foundation/utilities';

  export default {
    name: 'ProductStickyHeader',
    props: {
      elementToDisplayAfter: { type: String, required: false, default: '' } ,
    },
    data() {
      return {
        show: false
      };
    },
    computed: {
      displayAt() {
        const elementAfter = document.getElementById(this.elementToDisplayAfter);
        if (this.elementToDisplayAfter && elementAfter) {
          return elementAfter.offsetTop + elementAfter.offsetHeight;
        }
        return (window.innerHeight / 3) * 2;
      }
    },
    mounted() {
      /* istanbul ignore next */
      window.addEventListener('scroll', throttle(this.handleHeaderDisplay, 100));
    },
    methods: {
      handleHeaderDisplay() {
        if (window.pageYOffset > this.displayAt) {
          this.show = true;
        } else {
          this.show = false;
        }
      }
    }

  };
</script>
